<script>
export default {
    name: "ConsultantSupplierPayment",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "consultant-payment-form": () => import('./tabs/consultants/ConsultantPayment.vue'),
        "supplier-payment-form": () => import('./supplier/Form.vue')
    },
}
</script>
<template>
<tail-base-layout>
    <template v-slot:content>
        <tail-card>
            <template v-slot:card-header>
                <h5 class="font-medium text-base">Consultant/Supplier Payment Voucher</h5>
            </template>
            <template v-slot:card-body>
                <div class="w-full flex flex-wrap">
                   <ul class="print:hidden w-full flex border-b-2 border-gray-500">
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=0" href="javascript:void(0)" 
                            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===0 ? activeClass : inActiveClass">Consultant Payment</a>
                      </li>
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=1" href="javascript:void(0)" 
                            class="print:hidden btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===1 ? activeClass : inActiveClass">Supplier Payment</a>
                      </li>
                  </ul>
                  <consultant-payment-form v-if="active===0" />
                  <supplier-payment-form v-if="active===1" />
                </div>
            </template>
        </tail-card>
    </template>
</tail-base-layout>
</template>
